import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

function StaticPage({ slug }) {
  const { t } = useTranslation('staticPages');

  const title = t(`${slug}.title`);
  const content = t(`${slug}.content`);

  if (!title || title === `${slug}.title`) {
    return (
      <Container sx={{ py: 5 }}>
        <Typography variant="h4" component="h1" gutterBottom>Page not found</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" component="h1" gutterBottom>{title}</Typography>
      <Box dangerouslySetInnerHTML={{ __html: content }} />
    </Container>
  );
}

export default StaticPage;